<tools-alert *mobxAutorun [header]="header" [message]="message" [imageUrl]="imageUrl" [buttonText]="nav.noInternalLinks ? '' : 'Return Home'" [buttonClass]="buttonClass" (buttonClick)="homeButtonClick()"></tools-alert>
